<template>
    
    <div class="school-detail-wraper">
        <div class="card-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="detail-top">
            <div class="top-logo">
                <img v-if="detail.gbdm"
                :src="imgBaseUrl+detail.gbdm+'.jpg'" :alt="detail.yxmc" width="100%">
            </div>
            <div class="top-mid">
                <div class="mid-school-name">
                    <h3 style="font-weight: 700 !important;">
                        {{ detail.yxmc }}
                    <template v-if="detail.sf985===1">
                        <img src="../../../assets/images/ico2.png" title="985">
                    </template>
                    <template v-if="detail.sf211===1">
                        <img src="../../../assets/images/ico1.png" title="211">
                    </template>
                    <template v-if="detail.sfsyl===1">
                        <img src="../../../assets/images/ico8.png" title="双一流">
                    </template>
                    <template v-if="detail.sf101===1">
                        <img src="../../../assets/images/ico9.png" title="101">
                    </template>
                    <template v-if="detail.yfyjsy===1">
                        <img src="../../../assets/images/ico3.png" title="研究生院">
                    </template>
                    </h3>
                    <el-button  type="primary" size="mini" @click="closeWin" plain round>关闭</el-button>
                </div>
                <div class="mid-school-nature">
                    <div class="nature-item">
                        <span>{{detail.yymc}}</span>
                    </div>
                    <!-- <div class="nature-item">
                        <span class="school-link">网址：{{detail.wz}}</span>
                    </div> -->
                </div>
            </div>
            <div></div>
        </div>
        <div class="detail-main">
            <div class="schoolIntro_con2">
                    <div class="catTitle2">
                        <h2>专业组历年数据对比</h2>
                    </div>
                    <div class="txt"  id="lqTab" v-if="zyzTotals.list&&zyzTotals.list.length>0">
                        <table class="info-data">
                            <tr>
                                <th rowspan="2">专业组</th>
                                <th rowspan="2">年度</th>
                                <th colspan="6">录取分</th>
                                <th colspan="3">等效分</th>
                                <th>计划人数</th>
                            </tr>
                            <tr>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>投档线</th>
                                <th>线差</th>
                                <el-tooltip placement="top">
                                <div slot="content">我的省排名{{userInfo.spm}}</div>
                                <th>入档位次</th>
                                </el-tooltip>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>今年</th>
                            </tr>
                                <!-- <tr v-for="(item,index) in zyzTotals.sub" :key="index">
                                <td :rowspan="zyzRowspan" v-if="index===0&&type==='1'">
                                    <a href="javascript:void(0)" style="color:#2186de;">[{{zyzTotals.zyz}}]</a>
                                    <span style="display:block;width:41px;height:5px"></span>
                                    <div class="collectBtn" v-if="zyzTotals.sfsc===0" @click="addCollect(zyzTotals.zyz,zyzTotals.sfsc)">加入收藏</div>
                                    <div class="collectBtn" v-if="zyzTotals.sfsc===1" @click="addCollect(zyzTotals.zyz,zyzTotals.sfsc)">取消收藏</div>
                                </td>
                                <td :rowspan="zyzRowspan" v-if="index===0&&type==='2'">
                                    <a href="javascript:void(0)" style="color:black;">{{zyzTotals.zyz}}</a>
                                </td>
                                <td>{{item.nd?item.nd:item.nd===0?'平均分':'-'}}</td>
                                <td>{{!item.zdf?'-':item.zdf}}</td>
                                <td>{{!item.pjf?'-':item.pjf}}</td>
                                <td>{{!item.zgf?'-':item.zgf}}</td>
                                <td>{{!item.tdx?'-':item.tdx}}</td>
                                <td>{{!item.xc?'-':item.xc}}</td>
                                <td>{{!item.rdwc?'-':item.rdwc}}</td>
                                <td v-if="item.nd===0" class="yuceTdx">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                <td v-if="item.nd!==0">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                <td>{{!item.pjtwf?'-':item.pjtwf}}</td>
                                <td>{{!item.zgtwf?'-':item.zgtwf}}</td>
                                <td :rowspan="zyzRowspan" v-if="index===0">{{zyzTotals.jnjhs}}</td>
                                </tr> -->
                                <tbody v-for="(item0,index0) in zyzTotals.list" :key="index0">
                                <tr v-for="(item,index) in item0.sub" :key="index">
                                    <td :rowspan="zyzRowspan" v-if="index===0">
                                        <a href="javascript:void(0)" style="color:black;">{{item0.zyz}}</a>
                                    </td>
                                    <td>{{item.nd?item.nd:item.nd===0?'平均分':'-'}}</td>
                                    <td>{{!item.zdf?'-':item.zdf}}</td>
                                    <td>{{!item.pjf?'-':item.pjf}}</td>
                                    <td>{{!item.zgf?'-':item.zgf}}</td>
                                    <td>{{!item.tdx?'-':item.tdx}}</td>
                                    <td>{{!item.xc?'-':item.xc}}</td>
                                    <td>{{!item.rdwc?'-':item.rdwc}}</td>
                                    <td v-if="item.nd===0" class="yuceTdx">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                    <td v-if="item.nd!==0">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                    <td>{{!item.pjtwf?'-':item.pjtwf}}</td>
                                    <td>{{!item.zgtwf?'-':item.zgtwf}}</td>
                                    <td :rowspan="zyzRowspan" v-if="index===0">{{item.jnjhs}}</td>
                                </tr>
                                </tbody>
                        </table>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex';
// import $ from 'jquery';
import {imgBaseUrl,xiaoguoBaseUrl} from '../../../common/imgBaseUrl';
export default {
data(){
    return{
        activeName:"1",
        detail:{
            logo:"",
            dz:"",
            yxmc:"",
            wz:"",
            jxsj:"",
            ls:"",
            xsrs:"",
            bsdgs:"",
            ssdgs:"",
            ysrs:"",
            nsbl:"",
            nvsbl:"",
            jj:"",
            lsjj:"",
            xfxx:"",
            jyqk:"",
            szdqmc:"",
            dh:"",
            dzyx:"",
            ylxks:[],
            zswz:"",
            zszc:"",
            yymc:"",
            sf985:0,
            sf211:0,
            sf101:0,
            yfyjsy:0,
            sfsyl:0,
            gbdm:"",
            xxlbmc:"",
            xxlb:"",
            ylxkSize:"",
            yxxh:"",
            pc:"",
            lx:"",
            zdzyTitle1:'',
            zdzyTitle2:'',
            zdzys1:[],
            zdzys2:[]
        },
        zyzTotals:{
            list:[]
        },
        zyData:[],
        xh:"",
        scZyzSize:0,
        isSc:0,
        zyz:"",
        collectLoading:false,
        zyzRowspan:"",
        maxwidth:300,
        zyTotals:[],
        detailTxt:"查看详情 >>",
        searchZy:'',
        schoolList:[],
        updateZyList:false,
        imgBaseUrl:imgBaseUrl,
        xiaoguoBaseUrl:xiaoguoBaseUrl,
        condition:"",
        zyzTotals2:{
            list:[]
        },
        detail2:{
            logo:"",
            dz:"",
            yxmc:"",
            wz:"",
            jxsj:"",
            ls:"",
            xsrs:"",
            bsdgs:"",
            ssdgs:"",
            ysrs:"",
            nsbl:"",
            nvsbl:"",
            jj:"",
            lsjj:"",
            xfxx:"",
            jyqk:"",
            szdqmc:"",
            dh:"",
            dzyx:"",
            ylxks:[],
            zswz:"",
            zszc:"",
            yymc:"",
            sf985:0,
            sf211:0,
            sf101:0,
            yfyjsy:0,
            sfsyl:0,
            gbdm:"",
            xxlbmc:"",
            xxlb:"",
            ylxkSize:"",
            yxxh:"",
            pc:"",
            lx:"",
            zdzyTitle1:'',
            zdzyTitle2:'',
            zdzys1:[],
            zdzys2:[]
        },
        showYxObj:{},
        zyTotals2:[],
        zyzRowspan2:"",
        zyz2:"",
        isSc2:"",
        zyData2:[]
    };
},
methods:{
    // 获取院校专业组详情数据
    async getZyzDeatil(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("lqTab"),text:"正在加载中"});
        const loading2=this.$loading({fullscreen:true,target:document.getElementById("zyData"),text:"正在加载中"});
        const { gbdm, zyz = null,pc,yxmc,yxxh,type=null } = this.$route.query;
        const res=await this.$http.postHttp("/yxcx/getYxZyzDetail",{
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        const selectZydhData=[];
        if(res.data.code===200){
            this.detail.logo=res.data.obj.yxml.logo;
            this.detail.dz=res.data.obj.yxml.dz;
            this.detail.wz=res.data.obj.yxml.xxwz;
            this.detail.yxmc=res.data.obj.yxmcStr;
            this.detail.jj=res.data.obj.yxml.jj;
            this.detail.jxsj=res.data.obj.yxml.jxsj;
            this.detail.ls=res.data.obj.yxml.ls;
            this.detail.xsrs=res.data.obj.yxml.xsrs;
            this.detail.bsdgs=res.data.obj.yxml.bsdgs;
            this.detail.ysrs=res.data.obj.yxml.ysrs;
            this.detail.ssdgs=res.data.obj.yxml.ssdgs;
            this.detail.nsbl=res.data.obj.yxml.nsbfb;
            this.detail.nvsbl=res.data.obj.yxml.nvsbfb;
            this.detail.xfxx=res.data.obj.yxml.xfxx;
            this.detail.jyqk=res.data.obj.yxml.jyqk;
            const zdzys=[...res.data.obj.zdzys];
            const zyArr1=[];
            const zyArr2=[];
            for(let i=0;i<zdzys.length;i++){
                if(zdzys[i].ylxx==='A类'){
                    zyArr1.push(zdzys[i]);
                }else if(zdzys[i].ylxx==='B类'){
                    zyArr2.push(zdzys[i]);
                }
            }
            this.detail.zdzyTitle1='A类';
            this.detail.zdzyTitle2='B类';
            this.detail.zdzys1=zyArr1;
            this.detail.zdzys2=zyArr2;
            this.detail.ylxks=res.data.obj.zdzys;
            this.detail.szdqmc=res.data.obj.yxml.szdqmc;
            this.detail.dh=res.data.obj.yxml.dh;
            this.detail.dzyx=res.data.obj.yxml.dzyj;
            this.detail.zswz=res.data.obj.yxml.zswz;
            this.detail.zszc=res.data.obj.yxml.zszc;
            this.detail.yymc=res.data.obj.yxml.yxywmc;
            this.detail.sf985=res.data.obj.yxml.sf985;
            this.detail.sf211=res.data.obj.yxml.sf211;
            this.detail.sfsyl=res.data.obj.yxml.sfsyl;
            this.detail.yfyjsy=res.data.obj.yxml.yfyjsy;
            this.detail.sf101=res.data.obj.yxml.sf101;
            this.detail.gbdm=res.data.obj.yxml.gbdm;
            this.detail.xxlb=res.data.obj.yxml.xxlb;
            this.detail.xxlbmc=res.data.obj.yxml.xxlbmc;
            this.detail.ylxkSize=res.data.obj.zdzysSize;
            this.detail.yxxh=res.data.obj.yxxhStr;
            this.detail.pc=pc;
            for(let i=1;i<7;i++){
                if(res.data.obj['zydh'+i]){
                    selectZydhData.push(res.data.obj['zydh'+i]);
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        if(zyz===''){
            zyz=null;
        }
        if(type===''){
            type=null
        }
        const res2=await this.$http.postHttp("/yxcx/getLqxqOther",{
            kl:this.userInfo.sxkm,
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        console.log(res2);
        if(res2.data.code===200){
            this.detail.yxmc=yxmc;
            this.detail.gbdm=gbdm;
            // this.zyzTotals=res2.data.obj.zyzTotals[0];
            const len=res2.data.obj.zyzTotals.length;
            const zyzs=res2.data.obj.zyzTotals;
            for(let i=0;i<len;i++){
                const zyz=zyzs[i].zyz;
                const isSc=res2.data.obj.zyz[zyz].isSc;
                if(isSc){
                    zyzs[i].isSc=1;
                }else{
                    zyzs[i].isSc=0;
                }
            }
            if(len===1){
                // const isSc=res2.data.obj.zyz[zyzs[0].zyz].isSc;
                const isSc=res2.data.obj.sfsc;
                if(isSc){
                    this.isSc=1;
                }else{
                    this.isSc=0;
                }
            }
            console.log(res2);
            this.zyzTotals.list=res2.data.obj.zyzTotals;
            // this.zyzTotals.zyz=res2.data.obj.zyz;
            // this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
            // this.zyz=res2.data.obj.zyzTotals[0].zyz;
            if(res2.data.obj.zyzTotals[0]&&res2.data.obj.zyzTotals[0].zyz){
                this.zyz=res2.data.obj.zyzTotals[0].zyz;
            }
            if(zyzs[0]&&res2.data.obj.zyz[zyzs[0].zyz]){
                this.zyTotals=res2.data.obj.zyz[zyzs[0].zyz].zylb;
            }
            this.showYxObj={gbdm,zyz,pc,yxmc,yxxh,type};
            if(res2.data.obj.zyzTotals[0]&&res2.data.obj.zyzTotals[0].sub){
                this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
                this.showYxObj.sub=res2.data.obj.zyzTotals[0].sub;
            }else{
                this.$message({
                    type:'error',
                    message:"没有查到相关数据"
                });
            }
            const zybzs=[...this.zyTotals];
            const bzlen=zybzs.length;
            for(let i=0;i<bzlen;i++){
                if(zybzs[i]){
                    zybzs[i].isRed=false;
                }
            }
            for(let i=0;i<bzlen;i++){
                console.log(zybzs[i]);
                if(zybzs[i].zybz&&zybzs[i].zybz.indexOf("色盲")>=0&&zybzs[i].zybz.indexOf("色弱")>=0){
                    zybzs[i].isRed=true;
                }
            }
            this.zyTotals=zybzs;
            if(zyzs[0]&&res2.data.obj.zyz[zyzs[0].zyz]){
                const zyData=[];
                const zylb=res2.data.obj.zyz[zyzs[0].zyz].zylb;
                const zyLen=res2.data.obj.zyz[zyzs[0].zyz].zylb.length;
                for(let i=0;i<zyLen;i++){
                    const subs=zylb[i].subs;
                    for(let j=0;j<subs.length;j++){
                        console.log(subs[j]);
                        if(j%4===0){
                            let selectZydhIndex=-1;
                        for(let k=0;k<selectZydhData.length;k++){
                            if(subs[j].zydh===selectZydhData[k]){
                                selectZydhIndex=k;
                                break;
                            }
                        }
                        if(selectZydhIndex>=0){
                            subs[j].zyBtnTxt='专业'+(selectZydhIndex+1);
                        }else{
                            subs[j].zyBtnTxt="填报";
                        }
                        subs[j].isDisabled=false;
                        }
                        zyData.push(subs[j]);
                    }
                }
                console.log(zyData);
                this.zyData=zyData;
            }
            const schoolObj={};
            schoolObj.yxmc=yxmc;
            schoolObj.yxxh=yxxh;
            schoolObj.zyz=zyz;
            schoolObj.sb=null;
            schoolObj.pc=pc;
            schoolObj.sf985=this.detail.sf985;
            schoolObj.sf211=this.detail.sf211;
            schoolObj.snjhrs=0;
            schoolObj.jnjhrs=0;
            schoolObj.snrdwc=0;
            schoolObj.jnrdwc=0;
            schoolObj.tdx=0;
            schoolObj.zdtwf=0;
            schoolObj.pjtwf=0;
            schoolObj.zgtwf=0;
            schoolObj.sfsc=res2.data.obj.sfsc;
            for(let i=0;i<selectZydhData.length;i++){
              if(selectZydhData[i]){
                schoolObj['zy'+(i+1)]=selectZydhData[i];
              }
            }
            const schoolArr=[];
            schoolArr.push(schoolObj);
            console.log(schoolObj);
            this.schoolList=[...schoolArr];
            // this.zyzRowspan=4;
            // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
            // this.zyzTotals.sfsc=res2.data.obj.sfsc;
        }else if(res2.data.code===500){
            if(res2.data.message){
                this.$message({message:res2.data.message,type:"error"});
            }else if(res2.data.msg){
                this.$message({message:res2.data.msg,type:"error"});
            }
        }else if(res2.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.status===409||res2.status===410||res2.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
        loading2.close();
        this.$forceUpdate();
    },
    // 关闭当前页面
    closeWin() {
                const userAgent = navigator.userAgent;
                if (userAgent.indexOf("Firefox") !== -1 || userAgent.indexOf("Chrome") !== -1) {
                    window.open('','_self').close();
                }else {
                    window.opener = null;
                    window.open("about:blank", "_self");
                    window.close();
                }
    },
},
computed:{
...mapState(["userInfo"])
},
async mounted(){
    await this.getZyzDeatil();
}
};
</script>
<style scoped lang="less">

/deep/ .el-table .yuceTdx{
    color: #ED4A09 !important;
}
#zyData{
    // width: 790px;
    // margin: 0 auto;
}
.school-detail-wraper{
    min-width:1100px;
    margin:0 auto;
    min-height:calc(100vh - 380px);
    min-height:-moz-calc(100vh - 380px);
    min-height:-webkit-calc(100vh - 380px);
    .card-top{
        width: 1100px;
        margin: 20px auto;
    }
    .detail-top{
        display: flex;
        align-items: center;
        // width: 1100px;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
        background-color: #fff;
        .top-logo{
            width: 80px;
            height: 80px;
            box-sizing: border-box;
            margin: 0 30px;
        }
        .top-mid{
            // width: 80%;
            width: 84%;
            box-sizing: border-box;
            color: #666;
        }
        .mid-school-name{
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            font-size: 18px;
            color: #333;
        }
        .mid-school-nature{
            display: flex;
            font-size: 14px;
            .nature-item{
                flex: 1;
                .school-link{
                    cursor: pointer;
                }
            }
        }
    }
    .detail-main{
        box-sizing: border-box;
        // width: 1100px;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
    }
}
.schoolIntro_con2 {
    // width: 790px;
    // width: 890px;
    // width: 990px;
    width: 1104px;
    padding-top: 0;
    overflow: hidden;
    // margin: 0 20px 50px 190px;
    min-height: 500px;
    margin-left:15px;
    // padding-top: 130px;
}
.catTitle2 {
    height: 35px;
    border-left: 5px solid #5287c6;
    padding-left: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    h2{
        font-size: 26px;
        line-height: 35px;
        font-weight: normal;
        color: #333;
    }
}
.info-data{
    width: 100%;
    color: #666;
    th{
        border: 1px solid #09f;
        padding: 1px 0;
        text-align: center;
        background-color: #e4f5ff;
    }
    td{
        padding: 1px 5px;
        border: 1px solid #09f;
        text-align: center;
    }
}
.schoolIntro_con {
    // margin: 30px 0 30px 180px;
    min-height: 500px;
    width: 510px;
    float: left;
    display: inline;
    .intro{
        text-align: justify;
        word-wrap: break-word;
        margin-bottom: 15px;
    }
    .txt{
        text-align: justify;
        word-wrap: break-word;
        margin-bottom: 35px;
    }
    a{
        color: #2186de;
    }
}
.baseInfo{
    border-top: 2px solid #efaf49;
    // background: url(school.css);
    line-height: 33px;
    margin-bottom: 20px;
    height: 170px;
    li{
        height: 33px;
        vertical-align: top;
    }
    .t{
        float: left;
      }
      .c{
        float: right;
        text-align: right;
        color: #999;
      }
}
.clearfix {
    *zoom: 1;
}
.baseInfo_left {
    float: left;
    width: 47%;
}
.baseInfo_right {
    float: right;
    width: 47%;
}
.catTitle {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    margin-bottom: 10px;
    h2{
        font-size: 26px;
        line-height: 35px;
        font-weight: normal;
        color: #efaf49;
        text-align: left;
    }
}
.schoolIntro_side {
    float: right;
    width: 260px;
    margin-top: 30px;
    .infos{
        border: 1px solid #E5E5E5;
        border-top: 0;
        ul{
            padding: 5px 12px 12px 12px;
        }
        li{
            padding: 10px 0 10px 75px;
            border-bottom: 1px dashed #DDD;
            line-height: 18px;
            word-wrap: break-word;
            overflow: hidden;
        }
        label{
            float: left;
            margin-left: -75px;
        }
        .website{
            height: 30px;
            margin-left: 15px;
            margin-bottom: 10px;
            a{
                line-height: 28px;
                float: left;
                border: 1px solid #D6D6D6;
                border-radius: 5px;
                text-align: center;
            }
            .a1{
                width: 90px;
                margin-right: 13px;
            }
            .a2{
                width: 120px;
            }
        }
    }
}
.schoolIntro_sideBd {
    width: 260px;
}
.schoolPic_slide {
    width: 260px;
    height: 240px;
    overflow: hidden;
    position: relative;
    ul{
        width: 260px;
        height: 240px;
        overflow: hidden;
    }
    li{
        float: left;
    }
    img{
        width: 260px;
        height: 240px;
    }
}
.collectBtn{
    width: 36px;
    padding: 3px;
    margin: 0 auto;
    font-size: 13px;
    color: #fff;
    border: 1px solid #f17070;
    border-radius: 3px;
    background: #f17070;
    cursor: pointer;
    box-sizing: content-box;
}
.schoolIntro_con22 {
    width: 790px;
    padding-top: 0;
    overflow: hidden;
    margin-left:15px;
    .majorCon2 {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #efaf49;
    clear: left;
}
h3{
    font-size: 26px;
    line-height: 35px;
    font-weight: normal;
    color: #efaf49;
}
.majorCon1 {
    margin-bottom: 25px;
    .list{
        margin-bottom: 15px;
    // background: url(school.css);
    li{
        // background: url(school.css) no-repeat 28px 20px;
        text-indent: 18px;
        height: 45px;
        line-height: 45px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        float: left;
        width: 235px;
        padding-left: 15px;
        list-style: square;
    }
    }
}
}
.schoolIntro_con23 {
    width: 790px;
    padding-top: 0;
    overflow: hidden;
    margin-left:15px;
    .majorCon2 {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #efaf49;
    clear: left;
    h3{
        font-size: 26px;
    line-height: 35px;
    font-weight: normal;
    color: #efaf49;
    }
}
.txt{
    margin-bottom: 20px;
}
}
.yuceTdx{
    color: #ED4A09;
}
.yx_zy_group {
    box-sizing: border-box;
    border: 1px solid #eaeaea;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
}
.group_title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    padding: 5px;
    font-size: 18px;
    font-weight: 600;
    color: #fefefe;
    background: rgb(38, 190, 228);
    .collect{
        padding: 3px 10px;
        font-size: 14px;
        color: #fff;
        border: 1px solid #f17070;
        border-radius: 3px;
        background: #f17070;
        cursor: pointer;
    }
}
.group_content {
    padding: 10px 0 10px;
    border-bottom: 1px solid #eaeaea;
    .zy_name {
    width: 96%;
    padding-left: 15px;
    font-size: 16px;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .index{
        display: inline-block;
        padding: 0 6px;
        background-color: #5bc3ef33;
    }
    .tip{
        font-size: 14px;
        color: #606266;
    }
}
.zy_attrs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    margin: 10px 0 0;
    .attr-item:first-child {
    margin-left: 40px;
    }
    .attr-item {
    margin-right: 20px;
    padding: 0 10px;
    border-radius: 3px;
    font-size: 12px;
    color: #ff6900;
    background-color: #ff690021;
}
}
}
.seMangSeRuo{
    // font-size: 14px;
    // color: #606266;
    color: red;
}
h1, h2, h3, h4, h5, h6{
    font-weight: normal !important;
    margin: 0 !important;
}
p{
    margin-bottom: 0;
}

a {
    cursor: pointer;
    color: #333;
    text-decoration: none;
    -moz-outline: 0
}
</style>